<ng-container *transloco="let t;">
    <form [formGroup]="playbookForm" class="h-100">
            <div class="px-1 pt-1 d-flex h-100">
                <div class="guideline-main-wrapper d-flex w-100 h-100">
                    <div class="form-group">
                        <label class="col-form-label pt-0" for="">{{ t('Select playbook label title (Template/Legal hub tab - section) - Select playbook') }}</label>
                        <ng-select
                                [items]="playbooks$ | async"
                                [loading]="playbooksLoading$ | async"
                                formControlName="playbook"
                                bindLabel="name"
                                [clearable]="false"
                                [searchable]="true"
                                [placeholder]="t('Legal hub playbooks drop down label (Documents Section) - Select playbook')"
                                class="w-100 playbook-select"
                        >
                            <!-- Header with search box -->
                            <ng-template ng-header-tmp>
                                <input
                                        class="form-control w-100"
                                        type="text"
                                        [value]="searchSubject | async"
                                        (input)="searchPlaybook($event.target.value)"
                                        placeholder="Search playbooks..."
                                />
                            </ng-template>

                            <!-- Custom option -->
                            <ng-template ng-option-tmp let-item="item">
                                <div class="playbook-option">
                                    <div class="playbook-title">
                                        {{ item.name }}
                                        <span class="guidelines">
                                          ({{ item.playbook_guidelines_count || 0 }} {{ t('Legal hub playbooks drop down item text (Documents Section) - Guidelines')  }})
                                        </span>
                                    </div>
                                    <div class="playbook-meta">
                                        <div class="usage mb-50">
                                            <strong>{{ t('Legal hub playbooks drop down item text (Documents Section) - Usage') }}:</strong> {{ item.usage || '—' }}
                                        </div>
                                    </div>
                                </div>
                            </ng-template>

                            <!-- Selected value -->
                            <ng-template ng-label-tmp let-item="item">
                                <span class="selected-playbook">
                                  {{ item.name }} ({{ item.playbook_guidelines_count || 0 }} {{ t('Legal hub playbooks drop down item text (Documents Section) - Guidelines')}})
                                </span>
                            </ng-template>
                        </ng-select>
                        
                    </div>
                    @if(playbookForm?.get('playbook')?.value) {
                        @if((showPlaybookRunButton$| async) === true) {
                            <div class="d-flex justify-content-center">
                                <button type="button" (click)="runPlaybook()" [disabled]="playbookRunning$ | async" class="btn font-small-3 px-1 btn-success me-50" rippleEffect>
                                    {{t('Run Playbook button name (Documents Section) - Select playbook')}}
                                </button>
                            </div>
                        }
                        @if((existingPlaybookRun$ | async) !== null && (playbookRunning$ | async) === false && (guideLinesLoading$ | async) === false ) {
                            <div class="guideline-filter-container mt-2">
                                <label class="col-form-label pt-0">{{ t("Select filters status label title (Template/Legal hub tab - section) - Filter by guideline status") }}</label>
                                <app-guideline-list-status-filter [guideLines]="guideLines$ | async"
                                                                  [status]="(guideFilters$ | async)?.status"
                                                                  (statusChanged)="filterByStatus($event)"></app-guideline-list-status-filter>
                            </div>
                        }
                    }
                    <div class="guideline-filter-wrapper mt-3 d-flex h-100">
                        <div class="guidelines-card  h-100 w-100">
                            <div class="d-flex mb-1 justify-content-between align-items-center border-bottom">
                                <h6 class="mb-0">{{ t("Guideline status headline text (Template/Legal hub tab - section) - Guideline") }}</h6>
                                <div ngbDropdown class="menu-addon-icon text-center">
                                    <button type="button" class="btn btn-sm hide-arrow"
                                            rippleeffect
                                            ngbDropdownToggle data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false" href="javascript:void(0);">
                                        <i [data-feather]="'more-vertical'" [size]="18" class="text-body"></i>
                                    </button>
                                    <div ngbDropdownMenu class="dropdown-menu-right">
                                    <ng-container *ngTemplateOutlet="threeDotsDDLItem; context: {
                                        text: t('Three dots drop down item text (Document/template Legal hub right side bar ) - Run Playbook again'),
                                        action: runPlaybookAgain.bind(this),
                                        disabled: (existingPlaybookRun$ | async) === null
                                     }"></ng-container>

<!--                                     Scope of v4   -->
<!--                                    <ng-container *ngTemplateOutlet="threeDotsDDLItem; context: {-->
<!--                                        text: t('Three dots drop down item text (Document/template Legal hub right side bar ) - Apply all suggestions'),-->
<!--                                        action: applyAllSuggestions.bind(this)-->
<!--                                     }"></ng-container>-->

                                    <ng-container *ngTemplateOutlet="threeDotsDDLItem; context: {
                                        text: t('Three dots drop down item text (Document/template Legal hub right side bar ) - Clear Review'),
                                        action: onClearReviewClicked.bind(this),
                                        disabled: (existingPlaybookRun$ | async) === null
                                     }"></ng-container>
                                    </div>
                                </div>
                            </div>
                            @if(playbookForm?.get('playbook')?.value) {
                                 @if(guideLinesLoading$ | async) {
                                    <div class="ph-item guideline-loader contactlisting-placeholer-loader tableListing-loader contactListing-Loader activity-tab-signing">
                                        <div class="ph-col-12 px-0" *ngFor="let number of [0,1,2,3,4,5]">
                                            <div class="ph-row">
                                                <div class="ph-col-12 big"></div>
                                            </div>
                                        </div>
                                    </div>
                                }@else{
                                    <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="guideLineListScroll">
                                        <ul class="timeline guidelines-list h-100">
                                            @for (guideLine of (guideLines$ | async | guidelineListFilter : (guideFilters$ | async)); track guideLine) {
                                                <li class="timeline-item"  (click)="onGuideLineItemClick(guideLine)">
                                                    <app-playbook-guideline-run-tile [playbookRunning]="playbookRunning$ | async" [guideline]="guideLine"></app-playbook-guideline-run-tile>
                                                </li>
                                            } @empty {
                                                <div class="d-flex justify-content-center mt-1"><h6>{{t('Playbook does not have Guidelines notification (Documents Section) - There is no guideline to show')}}</h6></div>
                                            }
                                        </ul>
                                    </ng-scrollbar>
                                }
                            } @else {
                                <div class="d-flex justify-content-center mt-1"><h6>{{t('Not selected playbook notification (Documents Section) - Select playbook to display Guidelines')}}</h6></div>
                            }
                        </div>

                    </div>
                </div>
            </div>
    </form>
</ng-container>

<ng-template #threeDotsDDLItem let-text="text" let-action="action" let-disabled="disabled">
    <a ngbDropdownItem href="javascript:void(0)" (click)="action()" [disabled]="disabled">
        <span>{{text}}</span>
    </a>
</ng-template>